'use client';
import type { Assign } from '@ark-ui/react';
import { Switch } from '@ark-ui/react';
import {
  type SwitchRecipeVariantProps,
  switchRecipe,
} from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(switchRecipe);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLLabelElement,
  Assign<
    Assign<HTMLStyledProps<'label'>, Switch.RootProviderProps>,
    SwitchRecipeVariantProps
  >
>(Switch.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLLabelElement,
  Assign<
    Assign<HTMLStyledProps<'label'>, Switch.RootProps>,
    SwitchRecipeVariantProps
  >
>(Switch.Root, 'root');

export const Control = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, Switch.ControlProps>
>(Switch.Control, 'control');

export const Label = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, Switch.LabelProps>
>(Switch.Label, 'label');

export const Thumb = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, Switch.ThumbProps>
>(Switch.Thumb, 'thumb');

export const Context = Switch.Context;
export const HiddenInput = Switch.HiddenInput;
